import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { useWatch } from 'react-hook-form';

import { ReactComponent as UploadIcon } from '../../assets/icons/upload.svg';

const FileInput = ({
  placeholder = 'Click me to upload',
  error,
  label,
  control,
  name,
  register,
  ...props
}) => {
  const fileRef = useRef(null);
  const triggerFile = (e) => {
    e.preventDefault();
    fileRef.current.click();
  };

  const { ref, ...fileInputRef } = register ?? {};

  const files =
    useWatch({
      control,
      name
    }) ?? {};

  const fileKeys = Object.keys(files);
  const fileNamesArray = fileKeys?.map((fileKey) => files[fileKey]['name']);
  const fileName = fileNamesArray.join(', ');

  return (
    <div className="form__input--file">
      <button onClick={triggerFile}>
        <UploadIcon /> <br />
        {fileName ? fileName : placeholder}
      </button>
      <input
        type="file"
        {...props}
        {...fileInputRef}
        ref={(e) => {
          ref(e);
          fileRef.current = e;
        }}
      />
      <p>{label}</p>

      <p className="form__error">{error}</p>
    </div>
  );
};

FileInput.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  register: PropTypes.object,
  control: PropTypes.object
};

export { FileInput };
